import React from 'react'
import { Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'
import { merge, Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { ODIcon, ODIcons } from '../../icons'
export function ODSearchBox(props) {
  var placeholder = props.placeholder,
    _a = props.style,
    style = _a === void 0 ? {} : _a,
    _b = props.debounce,
    debounce = _b === void 0 ? 800 : _b,
    value = props.value,
    onChange = props.onChange,
    _c = props.numberOnly,
    numberOnly = _c === void 0 ? false : _c
  var _d = React.useState(''),
    keyword = _d[0],
    setKeyword = _d[1]
  var submitSubject = React.useRef(new Subject())
  var typingSubject = React.useRef(new Subject())
  var runSearch = React.useCallback(
    function (search) {
      var trimmed = search.trim()
      if (value !== trimmed) {
        onChange(trimmed)
      }
    },
    [value, onChange]
  )
  var handleSubmit = React.useCallback(function (e, word) {
    var _a
    ;(_a = e) === null || _a === void 0 ? void 0 : _a.preventDefault()
    submitSubject.current.next(word.trim())
  }, [])
  React.useEffect(
    function () {
      var sub = merge(typingSubject.current.pipe(debounceTime(debounce)), submitSubject.current)
        .pipe(distinctUntilChanged())
        .subscribe(function (s) {
          return runSearch(s)
        })
      return function () {
        return sub.unsubscribe()
      }
    },
    [debounce, runSearch]
  )
  return React.createElement(
    'div',
    { style: style },
    React.createElement(
      Form,
      {
        onSubmit: function (e) {
          return handleSubmit(e, keyword)
        },
      },
      React.createElement(
        FormGroup,
        null,
        React.createElement(
          InputGroup,
          { size: 'normal' },
          React.createElement(
            InputGroupAddon,
            { addonType: 'prepend' },
            React.createElement(
              InputGroupText,
              { style: { backgroundColor: 'transparent', borderRightColor: 'transparent' } },
              React.createElement(ODIcon, { icon: ODIcons.CoreSearch })
            )
          ),
          React.createElement(Input, {
            style: { borderLeftColor: 'transparent' },
            type: 'search',
            placeholder: placeholder,
            value: keyword,
            onChange: function (e) {
              if (numberOnly) {
                if (e.target.value.length > 0) {
                  var num = parseInt(e.target.value, 10)
                  if (isNaN(num)) {
                    return
                  }
                }
              }
              setKeyword(e.target.value)
              if (e.target.value.trim() === '') {
                submitSubject.current.next('')
              } else {
                typingSubject.current.next(e.target.value.trim())
              }
            },
          })
        )
      )
    )
  )
}
//# sourceMappingURL=ODSearchBox.js.map
